<template>
  <div>
    <!-- Input Security Text -->
    <div class="form-group row">
      <label for="security_text" class="col-sm-10 control-label">{{ $t('ct-checkout-security-content-label') }}</label>
      <div class="col-sm-10">
        <textarea type="text" class="form-control" id="security_text" name="security_text" @input="e.remove('security_text')" v-model="config.texts.security_text" :class="{'is-invalid': e.has('security_text')}" maxlength="132"></textarea>
        <small class="form-text text-danger" v-if="e.has('security_text')">{{ e.first('security_text') }}</small>
      </div>
    </div>

    <!-- Input Payment button text -->
    <div class="form-group row">
      <label for="payment_button" class="col-sm-10 control-label">{{ $t('ct-checkout-payment-button-label') }}</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" :class="{'is-invalid': e.has('payment_button')}" id="payment_button" name="payment_button" @input="e.remove('payment_button')" v-model="config.texts.payment_button" maxlength="40">
        <small class="form-text text-danger" v-if="e.has('payment_button')">{{ e.first('payment_button') }}</small>
        <span class="help-inline">{{ $t('ct-checkout-payment-button-help') }}</span>
      </div>
    </div>

    <!-- Form Submit -->
    <div class="form-group row">
      <div class="col-sm-offset-2 col-sm-10">
        <button type="reset" @click="$emit('cancel')" class="btn btn-outline-info btn-small">{{ $t('ct-checkout-select-another-product') }}</button>
        <button type="submit" class="btn btn-outline-success btn-small" @click="save">{{ $t('ct-save') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['config', 'e'],

  methods: {
    save() {
      this.e.clear();
      this.e.addValidation({
        security_text: 'required|max:132',
        payment_button: 'required|max:40'
      });
      if (this.e.validate(this.config.texts)) {
        this.$emit('save');
      } else {
        this.$nextTick(() => {
          document.querySelector('.is-invalid').focus();
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/Form/TextsOnestepConfig.vue